import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalTitle: {
    description: 'exportShipmentRecordsModal.title',
    defaultMessage: 'Export Shipments',
    id: 'l3VLFV',
  },
  recordType: {
    description: 'exportShipmentRecordsModal.exportShipments',
    defaultMessage: 'Export Shipments',
    id: 'gVK/1C',
  },
  recordTypeWithLineItem: {
    description: 'exportShipmentRecordsModal.exportLineItemShipments',
    defaultMessage: 'Export Shipment Line Items',
    id: 'eZVRdP',
  },
});
